import script from "./trash.vue?vue&type=script&lang=ts&setup=true"
export * from "./trash.vue?vue&type=script&lang=ts&setup=true"

import "./trash.vue?vue&type=style&index=0&id=276cfe15&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-276cfe15"]])

export default __exports__